<!-- 准入配置 -->
<template>
    <div class="whiteword">
        <!-- title -->
        <div style="display: flex; align-items: flex-end; margin-bottom: 15px">
            <span class="h2">准入配置</span>
            <span>当日批次的哪些数据,进入到系统中,影响模块:数据处理</span>
        </div>
        <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="platform" label="平台" header-align="center" align="center" width="180">
                <template #default="scope">
                    <img :src="_patformimaglogo(scope.row.platform)" v-if="_patformimaglogo(scope.row.platform)"
                        style="height: 100px; width: 100px" />
                    <span v-else style="display: block; height: 100px; width: 100px; line-height: 100px">{{
                        scope.row.platform }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="price" label="准入价位" header-align="center" align="center" min-width="180">
            </el-table-column>
            <el-table-column prop="brand" header-align="center" align="center" min-width="180" label="准入品牌">
            </el-table-column>
            <el-table-column prop="grade" header-align="center" align="center" min-width="100" label="准入等级">
            </el-table-column>
            <el-table-column prop="flaw" header-align="center" align="center" min-width="340" label="准入瑕疵">
                <template #default="scope">
                    <!-- {{  scope.row.flaw}} -->
                    <div style="text-align: left" v-for="item in scope.row.flaw" :key="item" :label="item">
                        {{ item }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="condition" header-align="center" align="center" min-width="100" label="准入成色">
            </el-table-column>
            <el-table-column prop="supplyGoods" header-align="center" align="center" min-width="100" label="准入货源">
            </el-table-column>
        </el-table>
        <!-- 内容 -->
        <div>
            <!-- 回收宝 -->
            <div>
                <!-- <el-divider> 回收宝 </el-divider> -->

                <!-- <el-descriptions direction="vertical" border style="margin-top: 20px"> -->
                <!-- <el-descriptions-item :rowspan="2" :width="140" label="品牌" align="center">
                        <el-image style="width: 100px; height: 100px" :src="_patformimaglogo('回收宝')" />
                    </el-descriptions-item>

                    <el-descriptions-item label="准入价位">0 ~ 4000</el-descriptions-item>
                    <el-descriptions-item label="准入品牌">全部安卓,苹果 13 pro max 以下(不含) </el-descriptions-item>
                    <el-descriptions-item label="准入等级">全部</el-descriptions-item>
                    <el-descriptions-item label="准入瑕疵"> 99,95,9,8,7,0 </el-descriptions-item> -->
                <!-- <el-descriptions-item label="Address"> No.1188, Wuzhong Avenue, Wuzhong District, Suzhou, Jiangsu Province </el-descriptions-item> -->
                <!-- </el-descriptions> -->
            </div>
            <!-- 采货侠 -->
            <div></div>
            <!-- 拍机堂 -->
            <div></div>
            <!-- 小当竞拍 -->
            <div></div>
        </div>
    </div>
</template>
<script>
import { patformimaglogo } from "@/utils/utils";
export default {
    data() {
        return {
            tableData: [
                {
                    platform: "回收宝",
                    price: "0 ~ 6000",
                    brand: "全部",
                    grade: "全部",
                    flaw: "无",
                    condition: "99,95,9,8,7,0",
                    supplyGoods: "官方货源",
                },
                {
                    platform: "采货侠",
                    price: "100~6000",
                    brand: "全部",
                    grade: "全部",
                    flaw: ["不入库：", "严重透图（严重老化）"],
                    condition: "99,95,9,8,7,0",
                    supplyGoods: "转转个人",
                },
                {
                    platform: "拍机堂",
                    price: "100~6000",
                    brand: "全部",
                    grade: "全部",
                    flaw: "无",
                    condition: "99,95,9,8,7,0",
                    supplyGoods: "官方质检（含爱回收自营）",
                },
                {
                    platform: "小当竞拍",
                    price: "100~6000",
                    brand: "全部",
                    grade: "全部",
                    flaw: "无",
                    condition: "99,95,9,8,7,0",
                    supplyGoods: ["可议价", "官方货源(可能与图片有关)"],
                },
            ],
        };
    },
    name: "letInSettingView",
    methods: {
        _patformimaglogo(sname) {
            return patformimaglogo(sname);
        },
    },
};
</script>

<style lang="scss" scoped>
.h2 {
    font-size: 1.5em;
    font-weight: bold;
    margin-right: 12px;
}

.whiteword {
    color: rgb(255, 255, 255);
}
</style>
